<template>
  <div>
    <el-select
      v-model="selectValue"
      :placeholder="placeholder"
      :disabled="disabled"
      :filterable="filterable + '' == 'true'"
      no-match-text="No data"
    >
      <el-option
        v-for="item in options"
        :key="item.value"
        :label="item.label"
        :value="item.value"
      >
      </el-option>
    </el-select>
  </div>
</template>

<script>
export default {
  name: "BdoSelect",

  props: {
    value: {
      type: [String, Number],
      default: "",
    },

    placeholder: {
      type: String,
      default: "",
    },
    // select option  (下拉框选项)
    options: {
      type: Array,
      default() {
        return [];
      },
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    filterable: {
      type: [Boolean, String],
      default: false,
    },
  },

  data() {
    return {
      selectValue: "",
    };
  },

  watch: {
    value(newValue) {
      this.selectValue = newValue;
    },

    selectValue(newValue) {
      this.$emit("input", newValue);
    },
  },
};
</script>

<style lang="scss" scoped>
</style>